import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "Page",
  class: "detail app-width cf pdg",
  "data-pdgb": "80",
  "data-offer": "true"
}
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "account" }
const _hoisted_4 = { class: "form" }
const _hoisted_5 = { class: "item" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "legend" }
const _hoisted_8 = { class: "form-items cf" }
const _hoisted_9 = {
  class: "form-items",
  "data-type": "cols"
}
const _hoisted_10 = { class: "item" }
const _hoisted_11 = { class: "control" }
const _hoisted_12 = {
  for: "Name",
  class: "label"
}
const _hoisted_13 = { class: "item" }
const _hoisted_14 = { class: "control" }
const _hoisted_15 = {
  for: "Surname",
  class: "label"
}
const _hoisted_16 = { class: "item" }
const _hoisted_17 = { class: "control" }
const _hoisted_18 = { class: "control" }
const _hoisted_19 = {
  for: "ProfileTaxType",
  class: "label"
}
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "item" }
const _hoisted_22 = { class: "control" }
const _hoisted_23 = {
  for: "TaxCode",
  class: "label"
}
const _hoisted_24 = {
  key: 0,
  class: "valid-sign"
}
const _hoisted_25 = {
  class: "item companydata",
  "data-type": "std"
}
const _hoisted_26 = { class: "control" }
const _hoisted_27 = {
  for: "Company",
  class: "label"
}
const _hoisted_28 = {
  class: "item companydata",
  "data-type": "std"
}
const _hoisted_29 = { class: "control" }
const _hoisted_30 = {
  for: "IVACode",
  class: "label"
}
const _hoisted_31 = {
  key: 0,
  class: "item companydata"
}
const _hoisted_32 = { class: "control" }
const _hoisted_33 = {
  for: "SDICode",
  class: "label"
}
const _hoisted_34 = {
  key: 1,
  class: "item companydata"
}
const _hoisted_35 = { class: "control" }
const _hoisted_36 = {
  for: "CertifiedEmail",
  class: "label"
}
const _hoisted_37 = ["disabled"]
const _hoisted_38 = { class: "form-items" }
const _hoisted_39 = { class: "item" }
const _hoisted_40 = { class: "control" }
const _hoisted_41 = {
  for: "Address",
  class: "label"
}
const _hoisted_42 = { class: "item" }
const _hoisted_43 = { class: "control" }
const _hoisted_44 = {
  for: "Location",
  class: "label"
}
const _hoisted_45 = { class: "item" }
const _hoisted_46 = { class: "control" }
const _hoisted_47 = {
  for: "PostCode",
  class: "label"
}
const _hoisted_48 = { class: "item" }
const _hoisted_49 = { class: "control" }
const _hoisted_50 = {
  for: "PostCode",
  class: "label"
}
const _hoisted_51 = ["value"]
const _hoisted_52 = {
  key: 0,
  class: "item"
}
const _hoisted_53 = { class: "control" }
const _hoisted_54 = {
  for: "Zone",
  class: "label"
}
const _hoisted_55 = ["value"]
const _hoisted_56 = { key: 1 }
const _hoisted_57 = { class: "item" }
const _hoisted_58 = { class: "control" }
const _hoisted_59 = {
  for: "Email",
  class: "label"
}
const _hoisted_60 = { class: "item" }
const _hoisted_61 = { class: "control" }
const _hoisted_62 = {
  for: "Phone",
  class: "label"
}
const _hoisted_63 = ["disabled"]
const _hoisted_64 = { class: "legend" }
const _hoisted_65 = {
  class: "form-items",
  "data-type": "cols"
}
const _hoisted_66 = { class: "item" }
const _hoisted_67 = { class: "control" }
const _hoisted_68 = {
  for: "ShippingCO",
  class: "label"
}
const _hoisted_69 = { class: "item" }
const _hoisted_70 = { class: "control" }
const _hoisted_71 = {
  for: "ShippingPhone",
  class: "label"
}
const _hoisted_72 = { class: "item" }
const _hoisted_73 = { class: "control" }
const _hoisted_74 = {
  for: "ShippingNotes",
  class: "label"
}
const _hoisted_75 = ["disabled"]
const _hoisted_76 = { class: "legend" }
const _hoisted_77 = {
  class: "form-items",
  "data-type": "cols"
}
const _hoisted_78 = { class: "item" }
const _hoisted_79 = { class: "control" }
const _hoisted_80 = {
  class: "label",
  for: "ShippingMode"
}
const _hoisted_81 = ["disabled"]
const _hoisted_82 = ["value"]
const _hoisted_83 = { class: "shipping-notes" }
const _hoisted_84 = {
  key: 0,
  id: "shipping-exwork-note"
}
const _hoisted_85 = ["href"]
const _hoisted_86 = {
  key: 1,
  id: "shipping-warehousepickup-note"
}
const _hoisted_87 = ["disabled"]
const _hoisted_88 = {
  class: "form-items",
  "data-type": "cols"
}
const _hoisted_89 = { class: "item" }
const _hoisted_90 = { class: "control" }
const _hoisted_91 = {
  for: "ShippingName",
  class: "label"
}
const _hoisted_92 = { class: "item" }
const _hoisted_93 = { class: "control" }
const _hoisted_94 = {
  for: "ShippingSurname",
  class: "label"
}
const _hoisted_95 = { class: "item" }
const _hoisted_96 = { class: "control" }
const _hoisted_97 = {
  for: "ShippingAddress",
  class: "label"
}
const _hoisted_98 = { class: "item" }
const _hoisted_99 = { class: "control" }
const _hoisted_100 = {
  for: "ShippingLocation",
  class: "label"
}
const _hoisted_101 = { class: "item" }
const _hoisted_102 = { class: "control" }
const _hoisted_103 = {
  for: "ShippingPostCode",
  class: "label"
}
const _hoisted_104 = { class: "item" }
const _hoisted_105 = { class: "control" }
const _hoisted_106 = {
  for: "ShippingCountry",
  class: "label"
}
const _hoisted_107 = ["value"]
const _hoisted_108 = {
  key: 0,
  class: "item"
}
const _hoisted_109 = { class: "control" }
const _hoisted_110 = {
  for: "ShippingZoneBox",
  class: "label"
}
const _hoisted_111 = ["value"]
const _hoisted_112 = ["disabled"]
const _hoisted_113 = { class: "legend" }
const _hoisted_114 = {
  class: "form-items mrg",
  "data-mrgt": "20",
  "data-type": "privacy"
}
const _hoisted_115 = { class: "item" }
const _hoisted_116 = { class: "checkbox" }
const _hoisted_117 = { for: "IsCheckoutValidated" }
const _hoisted_118 = { class: "disclaimer" }
const _hoisted_119 = ["href"]
const _hoisted_120 = {
  class: "fieldset mrg",
  "data-mrgt": "20"
}
const _hoisted_121 = {
  key: 0,
  class: "validation-summary-errors"
}
const _hoisted_122 = {
  class: "form-items",
  "data-type": "buttons"
}
const _hoisted_123 = { class: "item calltoaction" }
const _hoisted_124 = ["disabled"]
const _hoisted_125 = { class: "lable" }

import { ref, onBeforeMount } from "vue";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";


export default /*@__PURE__*/_defineComponent({
  __name: 'CheckoutProfileEdit',
  setup(__props) {

const localizer = Localizer;
const routes = (window as any).App.routes;

const isLoading = ref(true);
const isLoadingForm = ref(false);
const formData = ref<any>({
    isCheckoutValidated: false
});
const validationErrors = ref<any[]>([]);
const profileTaxTypes = ref<any[]>([]);
const countries = ref<any[]>([]);
const provinces = ref<any[]>([]);
const shippingModes = ref<any[]>([]);
const shippingAddressCountries = ref<any[]>([]);

async function getData() {
    const response = (await Axios.post(routes.Checkout_ProfileEdit_GetData)).data;

    formData.value = response.profile;
    profileTaxTypes.value = response.profileTaxTypes;
    countries.value = response.countries;
    provinces.value = response.provinces;
    shippingAddressCountries.value = response.shippingAddressCountries;

    if (formData.value.country) {
        await getShippingModes();
    }

    isLoading.value = false;
}

onBeforeMount(async () => {
    await getData();
});

async function getShippingModes() {
    FormHelper.removeFocus();

    validationErrors.value = [];

    isLoadingForm.value = true;

    try {
        const response = (await Axios.post(routes.Checkout_ProfileEdit_GetShippingModes, { countryCode: formData.value.country })).data;

        shippingModes.value = response;

        if (shippingModes.value.length === 1) {
            formData.value.shippingMode = shippingModes.value[0].value;
        }
    } catch (error: any) {
        if (error.response && error.response.status === 400) {
            validationErrors.value = FormHelper.getValidationErrors(error.response.data);
        }
    }

    isLoadingForm.value = false;
}

async function submitForm() {
    FormHelper.removeFocus();

    validationErrors.value = [];

    isLoadingForm.value = true;

    try {
        await Axios.post(routes.Checkout_ProfileEdit, formData.value);

        GTagHelper.sendEvent("form_submit", "account_profileedit");

        window.location.href = routes.Checkout_Summary;
    } catch (error: any) {
        if (error.response && error.response.status === 400) {
            validationErrors.value = FormHelper.getValidationErrors(error.response.data);
        }
    }

    isLoadingForm.value = false;
}

function isValidationError(controlName: string): boolean {
    return FormHelper.isControlValidationError(controlName, validationErrors.value);
}

return (_ctx: any,_cache: any) => {
  return (!isLoading.value)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(localizer).get("App.Common.YourProfile")), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("fieldset", {
                class: "fieldset mrg",
                "data-mrgt": "20",
                "data-row": "2",
                disabled: isLoadingForm.value
              }, [
                _createElementVNode("legend", _hoisted_7, _toDisplayString(_unref(localizer).get("Checkout.Common.ProfileData")), 1),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("label", _hoisted_12, _toDisplayString(_unref(localizer).get("Checkout.Common.Profile_Name")), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: "Name",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.name) = $event)),
                          class: _normalizeClass([{ 'input-validation-error': isValidationError('Name') }, 'textbox'])
                        }, null, 2), [
                          [
                            _vModelText,
                            formData.value.name,
                            void 0,
                            { lazy: true }
                          ]
                        ]),
                        _cache[29] || (_cache[29] = _createElementVNode("span", { class: "valid-sign" }, "*", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("label", _hoisted_15, _toDisplayString(_unref(localizer).get("Checkout.Common.Profile_Surname")), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: "Surname",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.surname) = $event)),
                          class: _normalizeClass([{ 'input-validation-error': isValidationError('Surname') }, 'textbox'])
                        }, null, 2), [
                          [
                            _vModelText,
                            formData.value.surname,
                            void 0,
                            { lazy: true }
                          ]
                        ]),
                        _cache[30] || (_cache[30] = _createElementVNode("span", { class: "valid-sign" }, "*", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("label", _hoisted_19, _toDisplayString(_unref(localizer).get("Checkout.Common.Profile_ProfileTaxTypes")), 1),
                          _withDirectives(_createElementVNode("select", {
                            id: "ProfileTaxType",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.profileTaxType) = $event)),
                            class: _normalizeClass([{ 'input-validation-error': isValidationError('ProfileTaxType') }, 'dropdown'])
                          }, [
                            _cache[31] || (_cache[31] = _createElementVNode("option", { value: null }, "...", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(profileTaxTypes.value, (profileTaxType, index) => {
                              return (_openBlock(), _createElementBlock("option", {
                                value: profileTaxType.value,
                                key: index
                              }, _toDisplayString(profileTaxType.title), 9, _hoisted_20))
                            }), 128))
                          ], 2), [
                            [
                              _vModelSelect,
                              formData.value.profileTaxType,
                              void 0,
                              { lazy: true }
                            ]
                          ]),
                          _cache[32] || (_cache[32] = _createElementVNode("span", { class: "valid-sign" }, "*", -1))
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("label", _hoisted_23, _toDisplayString(_unref(localizer).get("Checkout.Common.Profile_TaxCode")), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: "TaxCode",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.taxCode) = $event)),
                          class: _normalizeClass([{ 'input-validation-error': isValidationError('TaxCode') }, 'textbox'])
                        }, null, 2), [
                          [
                            _vModelText,
                            formData.value.taxCode,
                            void 0,
                            { lazy: true }
                          ]
                        ]),
                        (formData.value.country === 'IT' && formData.value.profileTaxType !== 'LegalPerson')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_24, "*"))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    (formData.value.profileTaxType === 'LegalPerson')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("label", _hoisted_27, _toDisplayString(_unref(localizer).get("Checkout.Common.Profile_Company")), 1),
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                id: "Company",
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.company) = $event)),
                                class: _normalizeClass([{ 'input-validation-error': isValidationError('Company') }, 'textbox'])
                              }, null, 2), [
                                [
                                  _vModelText,
                                  formData.value.company,
                                  void 0,
                                  { lazy: true }
                                ]
                              ]),
                              _cache[33] || (_cache[33] = _createElementVNode("span", { class: "valid-sign" }, "*", -1))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, [
                              _createElementVNode("label", _hoisted_30, _toDisplayString(_unref(localizer).get("Checkout.Common.Profile_IVACode")), 1),
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                id: "IVACode",
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.ivaCode) = $event)),
                                class: _normalizeClass([{ 'input-validation-error': isValidationError('IVACode') }, 'textbox'])
                              }, null, 2), [
                                [
                                  _vModelText,
                                  formData.value.ivaCode,
                                  void 0,
                                  { lazy: true }
                                ]
                              ]),
                              _cache[34] || (_cache[34] = _createElementVNode("span", { class: "valid-sign" }, "*", -1))
                            ])
                          ]),
                          (formData.value.country === 'IT')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                _createElementVNode("div", _hoisted_32, [
                                  _createElementVNode("label", _hoisted_33, _toDisplayString(_unref(localizer).get("Checkout.Common.Profile_SDICode")), 1),
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    id: "SDICode",
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.sdiCode) = $event)),
                                    class: _normalizeClass([{ 'input-validation-error': isValidationError('SDICode') }, 'textbox'])
                                  }, null, 2), [
                                    [
                                      _vModelText,
                                      formData.value.sdiCode,
                                      void 0,
                                      { lazy: true }
                                    ]
                                  ]),
                                  _cache[35] || (_cache[35] = _createElementVNode("span", { class: "valid-sign" }, "*", -1))
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (formData.value.country === 'IT')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                _createElementVNode("div", _hoisted_35, [
                                  _createElementVNode("label", _hoisted_36, _toDisplayString(_unref(localizer).get("Checkout.Common.Profile_CertifiedEmail")), 1),
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    id: "CertifiedEmail",
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.certifiedEmail) = $event)),
                                    class: _normalizeClass([{ 'input-validation-error': isValidationError('CertifiedEmail') }, 'textbox'])
                                  }, null, 2), [
                                    [
                                      _vModelText,
                                      formData.value.certifiedEmail,
                                      void 0,
                                      { lazy: true }
                                    ]
                                  ]),
                                  _cache[36] || (_cache[36] = _createElementVNode("span", { class: "valid-sign" }, "*", -1))
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ])
                ])
              ], 8, _hoisted_6),
              _createElementVNode("fieldset", {
                class: "fieldset mrg",
                "data-mrgt": "20",
                "data-row": "2",
                disabled: isLoadingForm.value
              }, [
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("label", _hoisted_41, _toDisplayString(_unref(localizer).get("Checkout.Common.Profile_Address")), 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "Address",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.address) = $event)),
                        class: _normalizeClass([{ 'input-validation-error': isValidationError('Address') }, 'textbox'])
                      }, null, 2), [
                        [
                          _vModelText,
                          formData.value.address,
                          void 0,
                          { lazy: true }
                        ]
                      ]),
                      _cache[37] || (_cache[37] = _createElementVNode("span", { class: "valid-sign" }, "*", -1))
                    ])
                  ]),
                  _cache[46] || (_cache[46] = _createElementVNode("div", { class: "item" }, null, -1)),
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("label", _hoisted_44, _toDisplayString(_unref(localizer).get("Checkout.Common.Profile_Location")), 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "Location",
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.location) = $event)),
                        class: _normalizeClass([{ 'input-validation-error': isValidationError('Location') }, 'textbox'])
                      }, null, 2), [
                        [
                          _vModelText,
                          formData.value.location,
                          void 0,
                          { lazy: true }
                        ]
                      ]),
                      _cache[38] || (_cache[38] = _createElementVNode("span", { class: "valid-sign" }, "*", -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("label", _hoisted_47, _toDisplayString(_unref(localizer).get("Checkout.Common.Profile_PostCode")), 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "PostCode",
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.value.postCode) = $event)),
                        class: _normalizeClass([{ 'input-validation-error': isValidationError('PostCode') }, 'textbox'])
                      }, null, 2), [
                        [
                          _vModelText,
                          formData.value.postCode,
                          void 0,
                          { lazy: true }
                        ]
                      ]),
                      _cache[39] || (_cache[39] = _createElementVNode("span", { class: "valid-sign" }, "*", -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("label", _hoisted_50, _toDisplayString(_unref(localizer).get("Checkout.Common.Profile_Country")), 1),
                      _withDirectives(_createElementVNode("select", {
                        id: "Country",
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.value.country) = $event)),
                        onChange: _cache[12] || (_cache[12] = ($event: any) => (getShippingModes())),
                        class: _normalizeClass([{ 'input-validation-error': isValidationError('Country') }, 'dropdown'])
                      }, [
                        _cache[40] || (_cache[40] = _createElementVNode("option", { value: null }, "...", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(countries.value, (country, index) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: country.value,
                            key: index
                          }, _toDisplayString(country.title), 9, _hoisted_51))
                        }), 128))
                      ], 34), [
                        [
                          _vModelSelect,
                          formData.value.country,
                          void 0,
                          { lazy: true }
                        ]
                      ]),
                      _cache[41] || (_cache[41] = _createElementVNode("span", { class: "valid-sign" }, "*", -1))
                    ])
                  ]),
                  (formData.value.country == 'IT')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                        _createElementVNode("div", _hoisted_53, [
                          _createElementVNode("label", _hoisted_54, _toDisplayString(_unref(localizer).get("Checkout.Common.Profile_Provinces")), 1),
                          _withDirectives(_createElementVNode("select", {
                            id: "Zone",
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formData.value.zone) = $event)),
                            class: _normalizeClass([{ 'input-validation-error': isValidationError('Zone') }, 'dropdown'])
                          }, [
                            _cache[42] || (_cache[42] = _createElementVNode("option", { value: null }, "...", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(provinces.value, (province, index) => {
                              return (_openBlock(), _createElementBlock("option", {
                                value: province.value,
                                key: index
                              }, _toDisplayString(province.title), 9, _hoisted_55))
                            }), 128))
                          ], 2), [
                            [
                              _vModelSelect,
                              formData.value.zone,
                              void 0,
                              { lazy: true }
                            ]
                          ]),
                          _cache[43] || (_cache[43] = _createElementVNode("span", { class: "valid-sign" }, "*", -1))
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_56)),
                  _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("label", _hoisted_59, _toDisplayString(_unref(localizer).get("Checkout.Common.Profile_Email")), 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "email",
                        id: "Email",
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formData.value.email) = $event)),
                        class: _normalizeClass([{ 'input-validation-error': isValidationError('Email') }, 'textbox'])
                      }, null, 2), [
                        [
                          _vModelText,
                          formData.value.email,
                          void 0,
                          { lazy: true }
                        ]
                      ]),
                      _cache[44] || (_cache[44] = _createElementVNode("span", { class: "valid-sign" }, "*", -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_60, [
                    _createElementVNode("div", _hoisted_61, [
                      _createElementVNode("label", _hoisted_62, _toDisplayString(_unref(localizer).get("Checkout.Common.Profile_Phone")), 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "tel",
                        id: "Phone",
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((formData.value.phone) = $event)),
                        class: _normalizeClass([{ 'input-validation-error': isValidationError('Phone') }, 'textbox'])
                      }, null, 2), [
                        [
                          _vModelText,
                          formData.value.phone,
                          void 0,
                          { lazy: true }
                        ]
                      ]),
                      _cache[45] || (_cache[45] = _createElementVNode("span", { class: "valid-sign" }, "*", -1))
                    ])
                  ])
                ])
              ], 8, _hoisted_37),
              _createElementVNode("fieldset", {
                class: "fieldset mrg",
                "data-mrgt": "20",
                "data-row": "2",
                disabled: isLoadingForm.value
              }, [
                _createElementVNode("legend", _hoisted_64, _toDisplayString(_unref(localizer).get("Checkout.Common.Profile_ContactData")), 1),
                _createElementVNode("div", _hoisted_65, [
                  _createElementVNode("div", _hoisted_66, [
                    _createElementVNode("div", _hoisted_67, [
                      _createElementVNode("label", _hoisted_68, _toDisplayString(_unref(localizer).get("Checkout.Common.Profile_ShippingCO")), 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "ShippingCO",
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((formData.value.shippingCO) = $event)),
                        class: _normalizeClass([{ 'input-validation-error': isValidationError('ShippingCO') }, 'textbox'])
                      }, null, 2), [
                        [
                          _vModelText,
                          formData.value.shippingCO,
                          void 0,
                          { lazy: true }
                        ]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_69, [
                    _createElementVNode("div", _hoisted_70, [
                      _createElementVNode("label", _hoisted_71, _toDisplayString(_unref(localizer).get("Checkout.Common.Profile_Phone")), 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "tel",
                        id: "ShippingPhone",
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((formData.value.shippingPhone) = $event)),
                        class: _normalizeClass([{ 'input-validation-error': isValidationError('ShippingPhone') }, 'textbox'])
                      }, null, 2), [
                        [
                          _vModelText,
                          formData.value.shippingPhone,
                          void 0,
                          { lazy: true }
                        ]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_72, [
                    _createElementVNode("div", _hoisted_73, [
                      _createElementVNode("label", _hoisted_74, _toDisplayString(_unref(localizer).get("Checkout.Common.Profile_Note")), 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "tel",
                        id: "ShippingNotes",
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((formData.value.shippingNotes) = $event)),
                        class: _normalizeClass([{ 'input-validation-error': isValidationError('ShippingNotes') }, 'textbox'])
                      }, null, 2), [
                        [
                          _vModelText,
                          formData.value.shippingNotes,
                          void 0,
                          { lazy: true }
                        ]
                      ])
                    ])
                  ]),
                  _cache[47] || (_cache[47] = _createElementVNode("div", { class: "item" }, null, -1))
                ])
              ], 8, _hoisted_63),
              _createElementVNode("fieldset", {
                class: "fieldset mrg",
                "data-mrgt": "20",
                "data-row": "2",
                disabled: isLoadingForm.value
              }, [
                _createElementVNode("legend", _hoisted_76, _toDisplayString(_unref(localizer).get("Checkout.Common.Profile_ShippingData")), 1),
                _createElementVNode("div", _hoisted_77, [
                  _createElementVNode("div", _hoisted_78, [
                    _createElementVNode("div", _hoisted_79, [
                      _createElementVNode("label", _hoisted_80, _toDisplayString(_unref(localizer).get("Checkout.Common.Profile_ShippingMode")), 1),
                      _withDirectives(_createElementVNode("select", {
                        id: "ShippingMode",
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((formData.value.shippingMode) = $event)),
                        disabled: !formData.value.country,
                        class: _normalizeClass([{ 'input-validation-error': isValidationError('ShippingMode') }, 'dropdown'])
                      }, [
                        _cache[48] || (_cache[48] = _createElementVNode("option", { value: null }, "...", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shippingModes.value, (shippingMode, index) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: shippingMode.value,
                            key: index
                          }, _toDisplayString(shippingMode.title), 9, _hoisted_82))
                        }), 128))
                      ], 10, _hoisted_81), [
                        [
                          _vModelSelect,
                          formData.value.shippingMode,
                          void 0,
                          { lazy: true }
                        ]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_83, [
                    (formData.value.shippingMode === 'ExWork')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                          _createTextVNode(_toDisplayString(_unref(localizer).get("Checkout.Common.Shipping_ExWork_Note")) + " ", 1),
                          _createElementVNode("a", {
                            href: _unref(routes).Support_ShippingReturns + '#ExWorks',
                            class: "link"
                          }, _toDisplayString(_unref(localizer).get("App.Common.ShippingExWork_More")), 9, _hoisted_85)
                        ]))
                      : _createCommentVNode("", true),
                    (formData.value.shippingMode === 'WarehousePickup')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_86, _toDisplayString(_unref(localizer).get("Checkout.Common.Shipping_WarehousePickup_Note")), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ], 8, _hoisted_75),
              (formData.value.shippingMode == 'ShippingAddress')
                ? (_openBlock(), _createElementBlock("fieldset", {
                    key: 0,
                    class: "fieldset shippingdata-box",
                    "data-row": "2",
                    disabled: isLoadingForm.value
                  }, [
                    _createElementVNode("div", _hoisted_88, [
                      _createElementVNode("div", _hoisted_89, [
                        _createElementVNode("div", _hoisted_90, [
                          _createElementVNode("label", _hoisted_91, _toDisplayString(_unref(localizer).get("Checkout.Common.Profile_Name")), 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            id: "ShippingName",
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((formData.value.shippingName) = $event)),
                            class: _normalizeClass([{ 'input-validation-error': isValidationError('ShippingName') }, 'textbox'])
                          }, null, 2), [
                            [
                              _vModelText,
                              formData.value.shippingName,
                              void 0,
                              { lazy: true }
                            ]
                          ]),
                          _cache[49] || (_cache[49] = _createElementVNode("span", { class: "valid-sign" }, "*", -1))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_92, [
                        _createElementVNode("div", _hoisted_93, [
                          _createElementVNode("label", _hoisted_94, _toDisplayString(_unref(localizer).get("Checkout.Common.Profile_Surname")), 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            id: "ShippingSurname",
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((formData.value.shippingSurname) = $event)),
                            class: _normalizeClass([{ 'input-validation-error': isValidationError('ShippingSurname') }, 'textbox'])
                          }, null, 2), [
                            [
                              _vModelText,
                              formData.value.shippingSurname,
                              void 0,
                              { lazy: true }
                            ]
                          ]),
                          _cache[50] || (_cache[50] = _createElementVNode("span", { class: "valid-sign" }, "*", -1))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_95, [
                        _createElementVNode("div", _hoisted_96, [
                          _createElementVNode("label", _hoisted_97, _toDisplayString(_unref(localizer).get("Checkout.Common.Profile_Address")), 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            id: "ShippingAddress",
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((formData.value.shippingAddress) = $event)),
                            class: _normalizeClass([{ 'input-validation-error': isValidationError('ShippingAddress') }, 'textbox'])
                          }, null, 2), [
                            [
                              _vModelText,
                              formData.value.shippingAddress,
                              void 0,
                              { lazy: true }
                            ]
                          ]),
                          _cache[51] || (_cache[51] = _createElementVNode("span", { class: "valid-sign" }, "*", -1))
                        ])
                      ]),
                      _cache[58] || (_cache[58] = _createElementVNode("div", { class: "item" }, null, -1)),
                      _createElementVNode("div", _hoisted_98, [
                        _createElementVNode("div", _hoisted_99, [
                          _createElementVNode("label", _hoisted_100, _toDisplayString(_unref(localizer).get("Checkout.Common.Profile_Location")), 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            id: "ShippingLocation",
                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((formData.value.shippingLocation) = $event)),
                            class: _normalizeClass([{ 'input-validation-error': isValidationError('ShippingLocation') }, 'textbox'])
                          }, null, 2), [
                            [
                              _vModelText,
                              formData.value.shippingLocation,
                              void 0,
                              { lazy: true }
                            ]
                          ]),
                          _cache[52] || (_cache[52] = _createElementVNode("span", { class: "valid-sign" }, "*", -1))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_101, [
                        _createElementVNode("div", _hoisted_102, [
                          _createElementVNode("label", _hoisted_103, _toDisplayString(_unref(localizer).get("Checkout.Common.Profile_PostCode")), 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            id: "ShippingPostCode",
                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((formData.value.shippingPostCode) = $event)),
                            class: _normalizeClass([{ 'input-validation-error': isValidationError('ShippingPostCode') }, 'textbox'])
                          }, null, 2), [
                            [
                              _vModelText,
                              formData.value.shippingPostCode,
                              void 0,
                              { lazy: true }
                            ]
                          ]),
                          _cache[53] || (_cache[53] = _createElementVNode("span", { class: "valid-sign" }, "*", -1))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_104, [
                        _createElementVNode("div", _hoisted_105, [
                          _createElementVNode("label", _hoisted_106, _toDisplayString(_unref(localizer).get("Checkout.Common.Profile_Country")), 1),
                          _withDirectives(_createElementVNode("select", {
                            id: "ShippingCountry",
                            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((formData.value.shippingCountry) = $event)),
                            class: _normalizeClass([{ 'input-validation-error': isValidationError('ShippingCountry') }, 'dropdown'])
                          }, [
                            _cache[54] || (_cache[54] = _createElementVNode("option", { value: null }, "...", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shippingAddressCountries.value, (shippingAddressCountry, index) => {
                              return (_openBlock(), _createElementBlock("option", {
                                value: shippingAddressCountry.value,
                                key: index
                              }, _toDisplayString(shippingAddressCountry.title), 9, _hoisted_107))
                            }), 128))
                          ], 2), [
                            [
                              _vModelSelect,
                              formData.value.shippingCountry,
                              void 0,
                              { lazy: true }
                            ]
                          ]),
                          _cache[55] || (_cache[55] = _createElementVNode("span", { class: "valid-sign" }, "*", -1))
                        ])
                      ]),
                      (formData.value.shippingCountry == 'IT')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                            _createElementVNode("div", _hoisted_109, [
                              _createElementVNode("label", _hoisted_110, _toDisplayString(_unref(localizer).get("Checkout.Common.Profile_Provinces")), 1),
                              _withDirectives(_createElementVNode("select", {
                                id: "ShippingZoneBox",
                                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((formData.value.shippingZone) = $event)),
                                class: _normalizeClass([{ 'input-validation-error': isValidationError('ShippingZone') }, 'dropdown'])
                              }, [
                                _cache[56] || (_cache[56] = _createElementVNode("option", { value: null }, "...", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(provinces.value, (shippingZone, index) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    value: shippingZone.value,
                                    key: index
                                  }, _toDisplayString(shippingZone.title), 9, _hoisted_111))
                                }), 128))
                              ], 2), [
                                [
                                  _vModelSelect,
                                  formData.value.shippingZone,
                                  void 0,
                                  { lazy: true }
                                ]
                              ]),
                              _cache[57] || (_cache[57] = _createElementVNode("span", { class: "valid-sign" }, "*", -1))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ], 8, _hoisted_87))
                : _createCommentVNode("", true),
              _createElementVNode("fieldset", {
                class: "fieldset mrg",
                "data-mrgt": "20",
                disabled: isLoadingForm.value
              }, [
                _createElementVNode("legend", _hoisted_113, _toDisplayString(_unref(localizer).get("Checkout.Common.Profile_DeclarationConsent")), 1),
                _createElementVNode("div", _hoisted_114, [
                  _createElementVNode("div", _hoisted_115, [
                    _createElementVNode("div", _hoisted_116, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        name: "IsCheckoutValidated",
                        id: "IsCheckoutValidated",
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((formData.value.isCheckoutValidated) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, formData.value.isCheckoutValidated]
                      ]),
                      _createElementVNode("label", _hoisted_117, _toDisplayString(_unref(localizer).get("Checkout.Common.Profile_PrivacyDisclaimer_Text")), 1),
                      _createElementVNode("span", _hoisted_118, [
                        _createElementVNode("a", {
                          href: _unref(routes).Terms_PrivacyPolicy,
                          target: "_blank",
                          class: "button-privacy"
                        }, _toDisplayString(_unref(localizer).get("Checkout.Common.Profile_PrivacyDisclaimer_Button")), 9, _hoisted_119)
                      ])
                    ])
                  ])
                ])
              ], 8, _hoisted_112),
              _createElementVNode("fieldset", _hoisted_120, [
                (validationErrors.value.length !== 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_121, [
                      _createElementVNode("ul", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(validationErrors.value, (validationError, index) => {
                          return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(validationError.message), 1))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_122, [
                  _createElementVNode("div", _hoisted_123, [
                    _createElementVNode("button", {
                      id: "ButtonSubmit",
                      class: "button",
                      onClick: _cache[28] || (_cache[28] = ($event: any) => (submitForm())),
                      disabled: isLoadingForm.value
                    }, [
                      _createElementVNode("span", _hoisted_125, _toDisplayString(_unref(localizer).get("Account.Common.Button_Next")), 1)
                    ], 8, _hoisted_124)
                  ])
                ])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})